import React from 'react';
import { Star } from 'lucide-react';

export default function Testimonials({
  isDark,
  testimonials,
  currentSlide,
  setCurrentSlide,
}) {
  return (
    <section
      className={`${
        isDark ? 'bg-gray-900' : 'bg-gradient-to-r from-orange-100 to-rose-100'
      } py-20 px-4`}
    >
      <div className='max-w-4xl mx-auto text-center'>
        <h2
          className={`text-4xl font-bold mb-12 ${
            isDark
              ? 'text-white'
              : 'bg-gradient-to-r from-orange-600 to-rose-600 bg-clip-text text-transparent'
          }`}
        >
          Відгуки клієнтів 💬
        </h2>

        <div
          className={`${
            isDark ? 'bg-gray-800' : 'bg-white/80'
          } backdrop-blur-sm border ${
            isDark ? 'border-gray-700' : 'border-orange-200'
          } rounded-2xl p-8 mb-8`}
        >
          <div className='text-5xl mb-4'>
            {testimonials[currentSlide].avatar}
          </div>
          <div className='flex justify-center mb-4'>
            {[...Array(testimonials[currentSlide].rating)].map((_, i) => (
              <Star
                key={i}
                className='w-5 h-5 text-yellow-400 fill-yellow-400'
              />
            ))}
          </div>
          <p
            className={`text-lg ${
              isDark ? 'text-gray-300' : 'text-gray-600'
            } mb-6 italic`}
          >
            "{testimonials[currentSlide].text}"
          </p>
          <div>
            <h4
              className={`font-bold ${isDark ? 'text-white' : 'text-gray-800'}`}
            >
              {testimonials[currentSlide].name}
            </h4>
            <p className={`${isDark ? 'text-orange-400' : 'text-orange-600'}`}>
              {testimonials[currentSlide].location}
            </p>
          </div>
        </div>

        <div className='flex justify-center space-x-2'>
          {testimonials.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentSlide(index)}
              className={`w-3 h-3 rounded-full transition-all duration-300 ${
                currentSlide === index
                  ? 'bg-orange-500 scale-125'
                  : isDark
                  ? 'bg-gray-600 hover:bg-gray-500'
                  : 'bg-orange-200 hover:bg-orange-300'
              }`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
